import CusMultipleFilter from 'components/CusMultipleFilter';
import useMain from 'hooks/useMain';
import moment from 'moment';
import React from 'react';
import { micService } from 'services/mic';
import { downloadExcel, getProject, handleAlertMessage, handleAsyncCall, OptionUtils } from 'utils/common';

const AccurarcyAlertReport = () => {
  const { t, useSelector, upperCaseLang } = useMain();
  const bcTypes = useSelector((state) => state.comModule.bcTypes);
  const bcTypeOptions = OptionUtils.localizeBctypeOptions(bcTypes, upperCaseLang);

  return (
    <CusMultipleFilter
      title={`${t('EXPORT')} ${t('')}`}
      filters={[
        {
          id: 'Bctype',
          label: t('BC_TYPE'),
          type: 'select',
          options: [{ label: t('ALL'), value: '*' }, ...bcTypeOptions]
        }
      ]}
      buttonLabel={t('EXPORT')}
      handleSubmit={(data) => {
        if (data?.Bctype) {
          handleAsyncCall({
            service: micService.getBcAlertReport,
            params: {
              projid: getProject().ProjId,
              bctype: data.Bctype,
              lang: upperCaseLang
            },
            successCb: (res) =>
              downloadExcel(
                res.data,
                `BCMS Data Accuracy Alert Report (${data.Bctype === '*' ? 'All' : data.Bctype}) ${moment(new Date()).format('YYYYMMDD')}`
              )
          });
          return;
        }

        handleAlertMessage({
          text: 'Please Select BC Type',
          showCancelButton: false
        });
      }}
    />
  );
};

export default AccurarcyAlertReport;
